import React from "react";

interface CardFanProps {
  firstCard: React.ReactNode;
  centerCard?: React.ReactNode;
  lastCard: React.ReactNode;
  className?: string;
}

const CardFan: React.FC<CardFanProps> = ({
  firstCard,
  centerCard,
  lastCard,
  className = "",
}) => {
  return (
    <div
      className={`flex justify-center items-center relative h-full ${className}`}
    >
      
      <div
        className="absolute left-1/2 z-10"
        style={{ transform: "translateX(-110%)" }}
      >
        {firstCard}
      </div>
      {centerCard && <div className="relative z-20">{centerCard}</div>}
      <div className="absolute left-1/2 z-10" style={{ transform: "translateX(10%)" }}>
        {lastCard}
      </div>
    </div>
  );
};

export default CardFan;
